import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import {
  getContentAnnounce,
  getContentDetail,
  getContentFaq,
  getContentList,
  getContentMenu,
} from "../endpoints/content";
import type { ContentMenu, ContentVo } from "../types/content";

const KEY = ["content"] as const;

export function useContentAnnounce() {
  return useQuery<ContentVo[]>({
    queryKey: [...KEY, "announce"],
    queryFn: () => getContentAnnounce({ baseUrl: API_BASE_URL }),
    staleTime: 5 * 60_000,
  });
}

export function useContentFaq() {
  return useQuery<ContentVo[]>({
    queryKey: [...KEY, "faq"],
    queryFn: () => getContentFaq({ baseUrl: API_BASE_URL }),
    staleTime: 5 * 60_000,
  });
}

export function useContentList(
  input: { position?: string; typeId?: string; tagCode?: string } = {},
) {
  return useQuery<ContentVo[]>({
    queryKey: [...KEY, "list", input.position, input.typeId, input.tagCode],
    queryFn: () => getContentList({ baseUrl: API_BASE_URL }, input),
    staleTime: 5 * 60_000,
  });
}

export function useContentDetail(input: { id?: string; code?: string }) {
  return useQuery<ContentVo>({
    queryKey: [...KEY, "detail", input.id, input.code],
    enabled: !!input.id || !!input.code,
    queryFn: () => getContentDetail({ baseUrl: API_BASE_URL }, input),
    staleTime: 10 * 60_000,
  });
}

export function useContentMenu(input: { position?: string; pid?: string } = {}) {
  return useQuery<ContentMenu[]>({
    queryKey: [...KEY, "menu", input.position, input.pid],
    queryFn: () => getContentMenu({ baseUrl: API_BASE_URL }, input),
    staleTime: 5 * 60_000,
  });
}
